/* global G */
import { check, checked } from 'lib/sequence/component/state/checked'
import { disable, enable } from 'lib/sequence/component/state/disabled'
import { bulk } from 'lib/util'
import { set, reset } from 'lib/sequence/component/state/value'

const bulkDisable = bulk(disable)
const bulkEnable = bulk(enable)

/**
 * Enables/Disables the `installationDate` field depending on the value of `installationDateUnknown`
 *
 * @param {Gaia.AppModule.Spec} module current module composition
 * @returns {function(*, ...[*]): Promise<*[]>}
 */
export default module => async (components, ...args) => {
  const model = module[G.MODEL]
  const { installationReport } = model[G.CHILDREN]
  const { installationDate: installationDateValidator } = installationReport[G.VALIDATOR]
  const {
    installationDateUnknown: { [G.CACHE]: installationDateUnknownCache = null } = {},
  } = installationReport[G.CHILDREN] || {}

  const { installationDate, installationDateUnknown } = components

  set(installationDateUnknown, true) // restoring value after model mapping destroyed it

  // Initializing CheckField according to model value
  // (i.e. setting field value only if current checked state is undefined)
  installationDateUnknownCache
    && checked(installationDateUnknown, true) === undefined
    && check(installationDateUnknown)

  checked(installationDateUnknown)
    ? bulkDisable(installationDate, installationDateValidator) && reset(installationDate)
    : bulkEnable(installationDate, installationDateValidator)

  return args
}
